import { connect } from 'react-redux';

import { SnackbarCloseReason } from '@mui/material/Snackbar/Snackbar';
import { Alert } from '@o2/ui';
import MultipleSnackbars from '@o2/ui/MultipleSnackbars';
import Snackbar from '@o2/ui/Snackbar';

import KahlAlert from './components/KahlAlert';
import { AppState } from 'helpers/store/models/AppState';
import { useTranslationWithDataKey } from 'hooks/useTranslationWithDataKey';
import { KahlMessage as Message, KahlSeverityMap } from 'models/KahlMessage';
import { selectIsUserInternal } from 'saga/auth/ducks';
import { closeKahlAction, selectKahlMessages } from 'saga/kahl/ducks';
import { selectProperty } from 'saga/property/ducks';

const KahlMessage = ({ messages, closeMessage, funnelUrl, isInternal }: StateToProps & DispatchToProps) => {
  const { t } = useTranslationWithDataKey();

  const handleClose = (id: string) => (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }

    closeMessage(id);
  };

  return (
    <MultipleSnackbars>
      {messages.map((message) => (
        <Snackbar key={message.id} open autoHideDuration={6000} onClose={handleClose(message.id)}>
          <Alert
            onClose={handleClose(message.id)}
            severity={KahlSeverityMap[`${message.errorType}`]}
            title={message?.stacktrace ? t('onecrm.general.KAHL.text.tooltip', false) : ''}
          >
            <KahlAlert message={message} funnelUrl={funnelUrl} isInternal={isInternal} />
          </Alert>
        </Snackbar>
      ))}
    </MultipleSnackbars>
  );
};

interface StateToProps {
  messages: Message[];
  funnelUrl: string;
  isInternal: boolean;
}

interface DispatchToProps {
  closeMessage: (id: string) => void;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  messages: selectKahlMessages(state),
  funnelUrl: selectProperty('FUNNEL.url'),
  isInternal: selectIsUserInternal(state),
});

const mapDispatchToProps: DispatchToProps = {
  closeMessage: closeKahlAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(KahlMessage);
